export enum StoreMapActions {
    SHOW_CONTAINER_POINTS = "showContainerPoints",
    SHOW_RECEPTIONPLACE_POINTS = "showReceptionPlacePoints",
    SHOW_INTERNALSTORE_POINTS = "showInternalStorePoints"
}